
// beware there is also a JS snippet in the de-minis partial.

var ready = function(){

  // show the correct imput box for the identification of the business
  // show a text field if the id is a reference from companies hours or vat number
  // show a file chooser if the id is a HMRC letter
  $('input[type="radio"][name="workplace_scheme_application[identified_by_type]"]').change(function(event){
    if( $(this).val() == "hmrc_letter" ){
      $('#identified-by-company-number-form-group').hide();
      $('#identified-by-vat-number-form-group').hide();
      $('#identified-by-file-form-group').show();
    } else if( $(this).val() == "vat_number" ) {
      $('#identified-by-company-number-form-group').hide();
      $('#identified-by-vat-number-form-group').show();
      $('#identified-by-file-form-group').hide();
    } else {
      $('#identified-by-company-number-form-group').show();
      $('#identified-by-vat-number-form-group').hide();
      $('#identified-by-file-form-group').hide();
    }
  });

  $('input[type="file"][id="workplace_scheme_application_identified_by_file"]').change(function(event) {
    var files = $('#workplace_scheme_application_identified_by_file')[0].files;
    $('#file_list').html('<div class="row"><div class="col-xs-6">new files: </div><div class="col-xs-6"><a href="#" onclick="return removeNewfile(event);" class="btn btn-danger btn-xs remove-newfile" >remove new files</a></div></div>');
    for (var i = 0, f; f = files[i]; i++) {
      $('#file_list').append( '<div class="row"><div class="col-xs-6">'+f.name+'</div><div class="col-xs-6"></div></div>' );
    }

  });

  $('.remove-newfile').click( function(event) {
    alert("remove new file");

    event.preventDefault();
  });





  $('.remove-attachment').click( function(event) {
    var storedAttachments = document.getElementById('workplace_scheme_application_storedAttachments').value;
    var obj = JSON.parse(storedAttachments);
    for(var i in obj)
    {
      if (this.id == obj[i].s3Filename)
      {
        obj.splice(i,1);
      }
    }
    $('#workplace_scheme_application_storedAttachments').val(JSON.stringify(obj));
    $(this.parentNode.parentNode).remove();
    event.preventDefault();
  });

  // show the small business size select box if the
  // '1-20' radion button is checked
  $('input[type="radio"][name="workplace_scheme_application[businessSize]"]').change(function(event){
    if( $(this).val() == '1-20' ) {
      $( '#small-business-size' ).show();
    } else {
      $( '#small-business-size' ).hide();
    }
  });

  // show the charity reference box if the
  // 'charity' radio button is checked
  $('input[type="radio"][name="workplace_scheme_application[businessType]"]').change(function(event){
    if( $(this).val() == 'charity' ) {
      $( '#charity_reference' ).show();
    } else {
      $( '#charity_reference' ).hide();
    }
  });

  // show or hide the franchise name text field depending on the state of the
  // 'is a franchise?' checkbox
  $('input[type="checkbox"][name="workplace_scheme_application[isFranchise]"]').change(function(event){
    if( $(this).is( ':checked' ) ) {
      $('#franchise-name-form-group').show();
    } else {
      $('#franchise-name-form-group').hide();
    }
  });


  // show or hide the de minimis declaration based on the type of business declared
  $('input[type="radio"][name="workplace_scheme_application[businessCategory]"]').change(function(event){
    if( $(this).val() == "publicsector" || $(this).val() == 'publicsector-nonprofit' ){
      $('#de-minimis').slideUp();
      $('#highlight-de-minimis').hide();
    } else {
      $('#de-minimis').slideDown();
      $('#highlight-de-minimis').text("Please complete the De Minimis section below");
      $('#highlight-de-minimis').show();
    }
  });

  $('#autoSelectable').click(selectText);
};

function selectText() {
        if (document.selection) {
            var range = document.body.createTextRange();
            range.moveToElementText(this);
            range.select();
        } else if (window.getSelection) {
            var range = document.createRange();
            range.selectNode(this);
            window.getSelection().addRange(range);
        }
};

// function to clear the choose file input
function removeNewfile(event) {
  $("#workplace_scheme_application_identified_by_file").val('');
  $('#file_list').html('');
  event.preventDefault();
}

$(document).ready(ready);
